import { combineReducers } from 'redux'
import { reducer as jPlayers } from 'react-jplayer'
import initiativeReducer from './initiativeReducer'

// where the redux store is build
export default combineReducers({
  initiatives: initiativeReducer,
  jPlayers
})
